// extracted by mini-css-extract-plugin
module.exports = {"button":"StakeItemButton_button__1oMzs","delisted":"StakeItemButton_delisted__33TFm","hidden":"StakeItemButton_hidden__1GAOH"};